import React from 'react';
import { motion } from 'framer-motion';
export function DiferencialHibrido() {
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-transparent text-[#2d2d2d] overflow-hidden" data-id="element-258" data-mp="292dgj32pesck">
      <div className="max-w-5xl mx-auto px-4 pl-[0px] pr-[0px]" data-id="element-259" data-mp="2d3fhboc9rcgn">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="w-full relative group" data-id="element-260" data-mp="2d0t7tj5timvs">
          <img src="https://cdn.magicpatterns.com/uploads/dX2KbmEFe3vZsnQHy7D4Ds/ChatGPT_Image_7_ago_2026,_16_34_26.webp" alt="La guía que necesitabas existe - Tarot Terapéutico Profesional" className="w-full h-auto" style={{
          paddingBottom: "15px"
        }} data-id="element-261" data-mp="1pca29be5ko7e" />

          {/* Premium Holographic CTA Button — overlaid on top of painted button area */}
          <div className="absolute bottom-[1.5%] left-1/2 -translate-x-1/2 w-[95%] z-30" data-id="element-262" data-mp="11lnrvdgoeru8">
            <motion.button onClick={scrollToPurchase} whileHover={{
            scale: 1.01
          }} whileTap={{
            scale: 0.98
          }} aria-label="Quiero transformar mi don" className="group/btn relative w-full cursor-pointer" style={{
            aspectRatio: '5.5 / 1'
          }} data-id="element-263" data-mp="21isuloud6t0z">
              {/* Holographic iridescent border (animated gradient) */}
              <span className="absolute inset-0 rounded-[14px] p-[1.5px] opacity-100 group-hover/btn:opacity-100 transition-opacity duration-500" style={{
              background: 'linear-gradient(120deg, #b794f4 0%, #f0abfc 18%, #fde68a 36%, #5eead4 54%, #93c5fd 72%, #c4b5fd 90%, #f0abfc 100%)',
              backgroundSize: '300% 300%',
              animation: 'mp-holo-shift 8s linear infinite'
            }} data-id="element-264" data-mp="1hweee3m474tf">
                {/* Inner dark fill */}
                <span className="block w-full h-full rounded-[12px] bg-black" data-id="element-265" data-mp="2ya4mdlgcud8c" />
              </span>

              {/* Outer glow on hover */}
              <span className="pointer-events-none absolute -inset-2 rounded-[20px] opacity-0 group-hover/btn:opacity-70 blur-xl transition-opacity duration-500" style={{
              background: 'linear-gradient(120deg, rgba(183,148,244,0.5), rgba(94,234,212,0.5), rgba(147,197,253,0.5))'
            }} data-id="element-266" data-mp="wjxgirktqqqw" />

              {/* Label + sparkles */}
              <span className="absolute inset-0 flex items-center justify-center px-4 gap-[20px]" data-id="element-267" data-mp="1fb6xflwxchsi">
                <span aria-hidden="true" className="text-[#fde68a] text-base md:text-2xl drop-shadow-[0_0_6px_rgba(253,224,138,0.6)]" data-id="element-268" data-mp="1ka9xery1rxtm">
                  ✦
                </span>
                <span className="font-black uppercase tracking-[0.18em] md:text-xl text-[10.5px]" style={{
                background: 'linear-gradient(90deg, #c4b5fd 0%, #fde68a 50%, #93c5fd 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }} data-id="element-269" data-mp="15f3qm2r4nuz8">
                  QUIERO TRANSFORMAR MI DON
                </span>
                <span aria-hidden="true" className="text-[#fde68a] text-base md:text-2xl drop-shadow-[0_0_6px_rgba(253,224,138,0.6)]" data-id="element-270" data-mp="285vdaoit498a">
                  ✦
                </span>
              </span>

              {/* Shine sweep — runs every ~4.5s */}
              <span className="absolute inset-0 overflow-hidden rounded-[14px] pointer-events-none" data-id="element-271" data-mp="2i4arxs0ndq0w">
                <span className="absolute top-0 -left-1/3 h-full w-1/3 skew-x-[-20deg]" style={{
                background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.18) 50%, transparent 100%)',
                animation: 'mp-shine-sweep 4.5s ease-in-out infinite'
              }} data-id="element-272" data-mp="1ueq6n2h0ugog" />
              </span>
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>;
}